export enum NetworkErrorCode {
  OFFLINE = 1401,
  SERVER = 500,
  UNAUTHORIZED = 401,
  UNKNOWN = 404,
  ERROR = 400,
  CANCELLED = 777,
  TOOMANYREQUESTS = 429,
}

export class CancelError extends Error {
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
  }
}

export class StorageError extends Error {
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
  }
}

export class NetworkError extends Error {
  code: number;

  isOffline: boolean;

  isUnauthorized: boolean;

  isApi400: boolean;

  isUnknown: boolean;

  isCancelled: boolean;

  isTooManyRequests: boolean;

  constructor(code: NetworkErrorCode, message: string) {
    super(message);
    this.code = code;
    this.isOffline = this.code === NetworkErrorCode.OFFLINE;
    this.isUnauthorized = this.code === NetworkErrorCode.UNAUTHORIZED;
    this.isApi400 = this.code === NetworkErrorCode.ERROR;
    this.isCancelled = this.code === NetworkErrorCode.CANCELLED;
    this.isTooManyRequests = this.code === NetworkErrorCode.TOOMANYREQUESTS;
    this.isUnknown =
      !this.isOffline &&
      !this.isUnauthorized &&
      !this.isApi400 &&
      !this.isTooManyRequests &&
      !this.isCancelled;
  }
}
